
import React from 'react';

export const ClipboardDocumentListIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    assignment
  </span>
);